<script setup lang="tsx">
import { ref } from 'vue'
import http from '@/services/http'
import columnStore from '@/stores/column'
import type { JournalOperation, Response } from '@/models/api-generated'
import LoadingContainer from '../widgets/LoadingContainer.vue'
import type { JournalFilter } from '@/models/filters-generated'
import OperationCard from './OperationCard.vue'

const props = withDefaults(
	defineProps<{
		component?: string
		filters?: JournalFilter[]
	}>(),
	{
		component: 'journal',
	},
)

const model = defineModel<JournalOperation[]>()
const isLoading = ref(false)
const root = columnStore().defineComponent(props.component, fetch)

async function fetch(signal: AbortSignal) {
	const request: JournalFilter[] = []
	if (props.filters) request.push(...props.filters)
	else request.push(root.filterValue() as JournalFilter)

	isLoading.value = true
	const { data } = await http.post<Response<JournalOperation[]>>(`api/journal`, request, { signal })
	isLoading.value = false

	if (data.data) model.value = data.data
}
</script>

<template>
	<LoadingContainer v-model="isLoading">
		<div class="w-100" v-if="model">
			<OperationCard v-for="(_, i) in model" :key="i" v-model="model[i]" :show-name="(props.filters?.length ?? 0) > 0" />
		</div>
	</LoadingContainer>
</template>

<style lang="sass" scoped>
td:hover
    cursor: pointer
</style>
